module.exports = __webpack_public_path__ + "static/media/statsIco1.185a3c49.svg";